import base from "../baseurl";
import token from "../getTk";

const showAll = async (weeklyFeeId) => {
  console.log("detalles de la campana");
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const show = await api
    .post("weekly-fees/show", {
      json: { weeklyFeeId },
    })
    .json();
  return show;
};

export default showAll;
